module.exports = __webpack_public_path__ + "img/秦皮.ec121d72.jpg";